import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { FeatureTogglesResource } from 'angular/resources/feature-toggles.resource';

angular
    .module('app')
    .factory(
        'featureTogglesResource',
        downgradeInjectable(FeatureTogglesResource)
    );
